import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"
import LogoImage from './../images/logo.svg'

export const Seo = ({ title, description, pathname, children, canonicalUrl, image }) => {
  const { title: defaultTitle, description: defaultDescription, siteUrl, twitterUsername } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  }

  return (
    <>
    <html lang="en"/>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:site_name" content="Garden Hub"></meta>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta name="google-adsense-account" content="ca-pub-9508155216365173"></meta>
      <link rel="icon" href={LogoImage} type="image/svg+xml" />
      <link rel="canonical" href={`https://www.gardnhub.com${canonicalUrl}/`} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Garden Hub",
          "alternateName": "GardnHub",
          "url": "https://gardnhub.com/"
        })}
      </script>
      
      {/* <script type='text/javascript' src='//pl24851667.profitablecpmrate.com/8a/4b/66/8a4b66e66d24234928854534b2fbf2d9.js'></script> */}
      {children}
    </>
  )
}